import { render, staticRenderFns } from "./WhatsAppSettingsQRCodeModal.vue?vue&type=template&id=05ae8042&scoped=true&"
import script from "./WhatsAppSettingsQRCodeModal.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSettingsQRCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae8042",
  null
  
)

export default component.exports